export const MAX_META_DESCRIPTION_LENGTH = 200
export const BOOKMATE_SUFFIX = ' — Bookmate'
export const BOOKMATE_SUFFIX_BAR = ' | Bookmate'
